import {TipoMonedaDTO} from './TipoMonedaDTO';

export class TotalesCFEDTO
{
  tipoMoneda: TipoMonedaDTO;
  tipoCambio: number;
  subtotal: number;
  montoIVAMinimo: number;
  montoIVABasico: number;
  montoIVASuspenso: number;
  montoIVA: number;
  montoTotal: number;
  cantidadLineasDetalles: number;

  // Propiedades de e-Resguardos (Inicio).
  montoTotalRetenidoEResg: number;
  montoTotalCreditoFiscalEResg: number;
  // Propiedades de e-Resguardos (Fin).

  public limpiar(): void
  {
    this.tipoMoneda = null;
    this.tipoCambio = null;
    this.subtotal = null;
    this.montoIVAMinimo = null;
    this.montoIVABasico = null;
    this.montoIVASuspenso = null;
    this.montoIVA = null;
    this.montoTotal = null;
    this.cantidadLineasDetalles = null;
    this.montoTotalRetenidoEResg = null;
    this.montoTotalCreditoFiscalEResg = null;
  }

  public toString(): string
  {
    const totalesCFEDTOStr: string = '(Tipo moneda: ' + this.tipoMoneda.descripcion + ', Tipo cambio: ' + this.tipoCambio + ', ' +
                                      'Subtotal: ' + this.subtotal + ', Monto IVA: ' + this.montoIVA + ', ' +
                                      'Monto total: ' + this.montoTotal + ', ' +
                                      'Cantidad líneas detalles: ' + this.cantidadLineasDetalles + ')';

    return totalesCFEDTOStr;
  }
}
